import { render, staticRenderFns } from "./SelectItem.vue?vue&type=template&id=312b4eb6&scoped=true"
import script from "./SelectItem.vue?vue&type=script&lang=js"
export * from "./SelectItem.vue?vue&type=script&lang=js"
import style0 from "./SelectItem.vue?vue&type=style&index=0&id=312b4eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b4eb6",
  null
  
)

export default component.exports